import React from 'react';
import './Resume.css';
// import EducationCard from './EducationCard.js';
import ExperienceCard from './ExperienceCard';
import SkillsCard from './SkillsCard';
import { FaDownload } from 'react-icons/fa';

function Resume({ResumeRef,downloadResume}) {


  const handleClick =()=>{
    return downloadResume();
  }

  return (
    <div ref = {ResumeRef}>
        <section className = "resume-container">
        <div className = "resume-title">
            <h1>Summary</h1>
            <div className = "resume-inner-title">
               <h2>Resume</h2>
            </div>
          </div>
          <section className="resume-body">
         
            {/* <div className="education">
              <h1>Education</h1>
                  <EducationCard
                    year = "2021-2024"
                    degree = "Fullstack Engineering Course"
                    university = "Codecademy Career Path"
                    description = "Studying front-end technologies such as html, css, and javascript as well as frameworks react/redux. Studying back-end technologies such as node.js, express.js, and posgresql. Have built several different projects regarding these technologies."
                  />
                  <EducationCard 
                      year = "2008-2011" 
                      degree = "Bachelors Degree in Electrical Engineering"
                      university = "University of Southern California"
                      description = "Emphasis on VLSI and analog circuit design and analysis. Used technologies such as Matlab, Verilog/VHDL, SPICE, and C++."
                  />
            </div> */}
           
            <div className = "experience">
            <h1>Notable Work Experience</h1>
            <ExperienceCard
              year = "Mar 2024 - present"
              occupation = "Fullstack Software Developer"
              company = "Cadenza Property Management"
              description = {`I manage and maintain the admin website that retrieves property information. I manage the backend server and database. I build scripts to automate payroll and budget reports.
                I automate owners reports. I help with building the pricing models. I'm currently collaborating on an AI chat bot project that responds to guest messages.
                Technologies that I use are javascript/jquery, node.js, express.js, mysql, python, github, github action,
                docker containers, aws ec2, aws rds, aws ecs, aws event bridge, aws api gateway, and aws lambda.`}
               />
            <ExperienceCard
              year = "Jan 2024 - Mar 2024"
              occupation = "Software Developer Intern"
              company = "Gala"
              description = {`Worked on an application that takes a customers question or response, and uses AI to return a valid answer. 
                Technologies that I am using are React.js, Django, PHP, Flutter, Tailwind CSS.`}
               />
            <ExperienceCard
              year = "Dec 2023 - Jan 2024"
              occupation = "Freelance Web Developer"
              company = "Purgace"
              description = "Responsible for site design and functionality using wordpress, css, and javascript. I am also responsible for API design using 3rd party platforms"
               />
               <ExperienceCard
              year = "Sep 2022 - Dec 2023"
              occupation = "Math Teacher"
              company = "Lexington Singapore School"
              description = "I currently teach 1st, 2nd, 3rd, and 4th grade math"
               />
              {/* <ExperienceCard 
               year = "Jul 2016 - Aug 2022"
               occupation = "English as a Second Language (ESL) Teacher"
               company = "VIPKid"
               description = "I teach students remotely. Lessons cover different exercises ranging from reading, vocabulary, grammar, pronunciation, and listening."
               />
              <ExperienceCard 
               year = "Sep 2016 - Jul 2016"
               occupation = "English Teacher"
               company = "Self-Employed"
               description = "Taught English as a second language internationally"
               />
               <ExperienceCard 
               year = "Jan 2012 - Aug 2015"
               occupation = "Systems Installation Engineer"
               company = "Panasonic Avionics Corporation"
               description = "Designed and developed Global Communication Systems and In-Flight Entertainment Systems interconnects to ensure proper interfacing with existing aircraft equipment for international airlines such as Etihad Airways and China Southern Airlines.Prepared engineering schematics with AutoCAD."
               />
                <ExperienceCard 
               year = "Jun 2011 - Nov 2011"
               occupation = "Product Realization Intern at T-Mobile USA"
               company = "T-Mobile Inc"
               description = "Tested Wi-Fi calling and collaborated with the engineering team to resolve any issues. Developed a basic understanding of wireless GSM/GPRS, handset client, content, and mobile web."
               /> */}
              
            </div>

          </section>
          <section className="skills">
            <h1>My Skills</h1>
            <SkillsCard />
          </section>
          <button className="resume-button" onClick={handleClick}>Download CV <FaDownload/></button>


        </section>
    </div>
  )
}

export default Resume